// extracted by mini-css-extract-plugin
export default {"SearchInput":"SearchInput__SearchInput___vPIzb"};